import Image from 'next/image'

interface GoogleLocalGuideProps {
  level?: number
}

export const GoogleLocalGuide: React.FC<GoogleLocalGuideProps> = ({
  level,
}) => {
  // If level is undefined or 0, show "未選択" (not selected)
  if (!level || level === 0) {
    return <span className="text-sm text-gray-700">未選択</span>
  }

  // Levels 1-3: Text only
  if (level >= 1 && level <= 3) {
    return <span className="text-sm text-gray-700">レベル{level}</span>
  }

  // Levels 4-10: Icon + Text
  if (level >= 4 && level <= 10) {
    return (
      <div className="flex items-center gap-1">
        <Image
          src={`/images/google-local-guide/badge-level-${level}.png`}
          alt={`Level ${level} badge`}
          width={16}
          height={16}
          className="shrink-0"
        />
        <span className="text-sm text-gray-700 whitespace-nowrap">
          レベル{level}
        </span>
      </div>
    )
  }

  // Invalid level
  return <span className="text-sm text-gray-700">未選択</span>
}
